import Route from "../Route";

import { Switch } from "react-router-dom";
import { BoletoContextProvider } from "../../pages/site/boleto/contexts/BoletoContext";
import Listagem from "../../pages/site/boleto/Listagem";
import BoletoLogin from "../../pages/site/boleto/Login";

export default function Site() {
  return (
    <>
      <BoletoContextProvider>
        <Switch>
          <Route path="/site/boleto/listagem" component={Listagem} />
          <Route path="/site/boleto/login" component={BoletoLogin} />
        </Switch>
      </BoletoContextProvider>
    </>
  );
}
